import { Component, Prop } from 'vue-property-decorator';
import Vue from '@/VueBase';
import { mapState } from 'vuex';
import Q from 'q';

@Component({
  computed: {
    ...mapState(['CanCancelVote']),
  },
})
export default class SideBarMixins extends Vue {
  @Prop() public readonly selected!: CandidateSimpleModel[];
  @Prop() public readonly max!: number;
  @Prop() public readonly onlySelected!: boolean;
  @Prop() public readonly propShowScroller!: boolean;
  //@Prop() public readonly scrollContainer!: HTMLElement;
  public showScroller = this.propShowScroller;

  public isUpActive = false;
  public isDownActive = false;

  get scrollStep() {
    return 200;
  }

  async mounted() {
    this.scrollContainer.onscroll = () => this.onScroll();
    this.onScroll();
    await Q.delay(500);
    this.onScroll();
  }

  onCandidateClick(candidate: CandidateSimpleModel) {
    this.$emit('remove', candidate.Id);
  }

  onCancelVoteClick() {
    this.$emit('cancel');
  }

  async onSelectedClick() {
    this.$emit('update:onlySelected', !this.onlySelected);
    this.$nextTick(() => {
      this.onScroll();
    });
    await Q.delay(500);
    this.onScroll();
  }

  get scrollContainer() {
    return this.$parent.$refs.scrollContainer as HTMLElement;
  }

  get vsVoteSidebarPlaceholder1Line() {
    return process.env.VUE_APP_CLIENT != 'cpa';
  }

  scrollUp() {
    var pageTop = this.scrollContainer.scrollTop || 0;

    if (pageTop === 0) {
      return;
    }
    this.scrollContainer.scrollBy({
      top: -this.scrollStep,
      behavior: 'smooth',
    });
    // this.onScroll()
  }

  scrollDown() {
    var pageTop = this.scrollContainer.scrollTop || 0;
    var pageBottom = pageTop + this.scrollContainer.clientHeight;
    var pageSize = this.scrollContainer.scrollHeight;

    if (pageBottom >= pageSize) {
      return;
    }
    this.scrollContainer.scrollBy({
      top: this.scrollStep,
      behavior: 'smooth',
    });
    // this.onScroll()
  }

  onScroll() {
    var self = this;
    var scrollContainer = this.scrollContainer;
    var pageSize = scrollContainer.scrollHeight;

    if (self.propShowScroller) {
      self.showScroller = pageSize > scrollContainer.clientHeight;
    }

    if (!self.showScroller) {
      return;
    }

    var pageTop = this.scrollContainer.scrollTop || 0;
    var pageBottom = pageTop + this.scrollContainer.clientHeight;
    this.isUpActive = pageTop > 0;
    this.isDownActive = pageSize > pageBottom;
  }
}
